import { render, staticRenderFns } from "./fulfilGiveFullReductionEdit.vue?vue&type=template&id=0fb559fe&"
import script from "./fulfilGiveFullReductionEdit.vue?vue&type=script&lang=js&"
export * from "./fulfilGiveFullReductionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports